<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :rows="rows"
        dom-layout="scroll"
        class="agGrid"
        :row-multi-select-with-click="true"
        @selectionChanged="selectionChanged"
      />
    </div>
    <div class="button-containers">
      <button
        :disabled="isDisableDelete"
        class="btn primary small outline"
        @click="deleteSource"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="isDisableModify"
        class="btn primary small"
        @click="updateView"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="!isEdit ? 'Thêm lý do' : 'Sửa lý do'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Mã lý do</div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    name="Mã lý do"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="form.code"
                        type="text"
                        :disabled="isEdit"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Lý do</div>
                  <validation-provider rules="required|max:100" name="Lý do">
                    <textarea
                      v-model="form.reason"
                      style="width: 100%"
                      rows="4"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>

            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label" style="margin-right: 10px">Hoạt động</div>

                  <el-switch
                    v-model="form.status"
                    active-color="#357456"
                    inactive-color="#CAC9C9"
                  />
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small outline"
            @click="updateSource"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small outline" @click="addSource">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import { CellRenderToggleSwitchReadOnly } from '@/utils/cellRenders.js'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import {
  getReasonCancelApi,
  addReasonCancelApi,
  updateReasonCancelApi,
  deleteReasonCancelApi
} from '@/api/Service_Policy/reasonCancel.js'

import { Message } from 'element-ui'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderToggleSwitchReadOnly,
    SelectWithSearchTable
  },
  data() {
    return {
      isDisableModify: true,
      isDisableDelete: true,
      loading: false,
      defaultForm: {
        code: '',
        reason: '',
        id: null,
        order: 0,
        status: true
      },
      form: {
        code: '',
        reason: '',
        id: null,
        order: 0,
        status: true
      },

      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        isActive: 2
      },
      sourceGroupOptions: [],
      columnsGroup: [
        {
          headerName: 'Mã nhóm',
          field: 'code',
          minWidth: 150,
          maxWidth: 180,
          sortable: false
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          flex: 1,
          sortable: false
          // cellRenderer: 'CellRenderTextInput',
        }
      ],

      columns: [
        {
          headerName: 'STT',
          field: 'no',
          sortable: false,
          width: 70,
          minWidth: 70,
          maxWidth: 100
        },
        {
          headerName: 'Mã lý do',
          field: 'code',
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Lý do',
          sortable: false,
          field: 'reason',
          flex: 1
          // cellRenderer: 'CellRenderTextInput',
        },

        {
          headerName: 'Hoạt động',
          sortable: false,
          field: 'status',
          cellRenderer: 'CellRenderToggleSwitchReadOnly',
          cellRendererParams: params => {
            return {
              active: params.data.status
            }
          },
          maxWidth: 200
        }
      ],

      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetItemInfo()
    }
  },
  beforeMount() {
    this.getSourceGroup()
  },

  async mounted() {
    this.attachData()
  },
  methods: {
    onSelectRowOption(val) {
      this.form.p_id = val.id
    },

    selectionChanged(rows) {
      if (rows.length == 0) {
        this.isDisableModify = true
        this.isDisableDelete = true
      } else if (rows.length > 1) {
        this.isDisableModify = true
        this.isDisableDelete = false
      } else {
        this.isDisableModify = false
        this.isDisableDelete = false
      }
    },
    async getSourceGroup() {
      let data = await getSourceGroupApi({ isActive: 1 })
      this.sourceGroupOptions = data.data
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },

    async attachData() {
      // bus.$emit("startLoader", { msg: "" });
      this.loading = true
      let data = await getReasonCancelApi(this.searchParams)
      this.loading = false
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : data.page_num
    },
    async addSource() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return

      let data = await addReasonCancelApi(this.form)
        .then(async res => {
          const message = res.message
          // if (this.isActive) {
          //   this.attachData({ isActive: 0 })
          // } else {
          //   this.attachData({ isActive: 1 })
          // }
          this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async updateSource() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await updateReasonCancelApi(this.form)
        .then(async res => {
          const message = res.message
          // if (this.isActive) {
          //   this.attachData({ isActive: 0 })
          // } else {
          //   this.attachData({ isActive: 1 })
          // }
          this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },

    async deleteSource() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteReasonCancelConfirm'), () => {
          deleteReasonCancelApi({
            id_list: id_list
          })
            .then(async res => {
              const message = res.message
              // if (this.isActive) {
              //   this.attachData({ isActive: 0 })
              // } else {
              //   this.attachData({ isActive: 1 })
              // }
              this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    addView() {
      this.isEdit = false
      this.dialogFormVisible = true
    },

    updateView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        console.log(rowsSelected)
        this.isEdit = true
        const rowData = rowsSelected[0]
        this.form.order = rowData.order
        this.form.id = rowData.id
        this.form.code = rowData.code
        this.form.reason = rowData.reason
        this.form.status = rowData.status
        this.dialogFormVisible = true
      }
    },

    resetItemInfo() {
      this.form = { ...this.defaultForm }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
